export var FormInputType = /* @__PURE__ */ ((FormInputType2) => {
  FormInputType2["TEXT"] = "text";
  FormInputType2["NUMBER"] = "number";
  FormInputType2["TIME"] = "time";
  return FormInputType2;
})(FormInputType || {});
export var InputSize = /* @__PURE__ */ ((InputSize2) => {
  InputSize2["SMALL"] = "small";
  InputSize2["MEDIUM"] = "medium";
  InputSize2["LARGE"] = "large";
  return InputSize2;
})(InputSize || {});
export var SwitchSelectorSize = /* @__PURE__ */ ((SwitchSelectorSize2) => {
  SwitchSelectorSize2["MEDIUM"] = "medium";
  SwitchSelectorSize2["LARGE"] = "large";
  return SwitchSelectorSize2;
})(SwitchSelectorSize || {});
export var CheckboxShape = /* @__PURE__ */ ((CheckboxShape2) => {
  CheckboxShape2["SQUARE"] = "square";
  CheckboxShape2["CIRCLE"] = "circle";
  return CheckboxShape2;
})(CheckboxShape || {});
